module.exports = __webpack_public_path__ + "img/2021jy_intro1.44911386.jpg";